import * as React from 'react';
import {
    BaseVariant,
    GetWhitelistedVariants,
    VariantOverrides,
} from 'notistack';
import UserCreatedSnackbar from './UserCreatedSnackbar';
import UnknownApiErrorSnackbar from './UnknownApiErrorSnackbar';
import { User } from '../../store/types';
import { AnyResponse } from '../../utils/response';
import ClientCreatedSnackbar from './ClientCreatedSnackbar';
import { Client } from '../../api/types/user';

declare module 'notistack' {
    interface VariantOverrides {
        userCreated: {
            user: User;
        };
        clientCreated: {
            client: Client;
        };
        unknownError: {
            response: AnyResponse | null;
        };
    }
}

type VariantMap = GetWhitelistedVariants<BaseVariant, VariantOverrides>;

export type VariantType = keyof VariantMap;

type SnackbarComponentType = {
    [variant in VariantType]?: React.JSXElementConstructor<any>;
};

const SnackbarComponents: SnackbarComponentType = {
    userCreated: UserCreatedSnackbar,
    clientCreated: ClientCreatedSnackbar,
    unknownError: UnknownApiErrorSnackbar,
};

export default SnackbarComponents;
